import axiosClient from './axiosClient';

export default {
  // Recupera tutte le notifiche dell’utente
  lista: async () => {
    const res = await axiosClient.get('/notifiche');
    return res.data;
  },

  // Segna una notifica come letta
  markAsRead: async (notificaId) => {
    const res = await axiosClient.put(`/notifiche/${notificaId}/lettura`);
    return res.data;
  },

  // Segna tutte le notifiche come lette
  segnaTutteLette: async () => {
    const res = await axiosClient.put('/notifiche/lettura');
    return res.data;
  },

  // Conta notifiche non lette
  unreadCount: async () => {
    const res = await axiosClient.get('/notifiche/unreadcount');
    return res.data;
  },

  // SSE / WebSocket con userId
  subscribe: (userId, onMessage) => {
    if (!userId) throw new Error("subscribe: userId non definito");

    console.log("Sottoscrizione notifiche per userId:", userId);

    const es = new EventSource(
      `${process.env.REACT_APP_API_URL}/stream/notifiche?userId=${userId}`
    );

    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        onMessage(data);
      } catch (err) {
        console.error("Errore parsing notifica SSE:", err);
      }
    };

    es.onerror = (err) => {
      console.error("Errore SSE:", err);
      es.close();
    };

    // restituisce funzione per chiudere l'SSE
    return () => es.close();
  },
};
